const P = true;
const NP = false;
const PI = true;
const PV = false;
function def(id, label, icon, percussive, pitchInvariant, description, pronunciation) {
    return {
        id,
        label,
        icon,
        percussive,
        pitchInvariant,
        description,
        pronunciation,
    };
}
export const PRESET_SPECS = [
    {
        id: "rolled-r",
        name: "Trills & Taps",
        version: 2,
        phonemes: [
            def("tap", "Tap (ɾ)", "▚", P, PI, "A single quick flick of the tongue against the ridge behind " +
                "the upper teeth — the sound in the middle of 'butter'.", "Let the tip of your tongue bounce once off the roof of your " +
                "mouth, just behind your teeth. Say 'ah-da' quickly."),
            def("trill", "Rolled R (r)", "〰", NP, PI, "A rolled/trilled R where the tongue vibrates rapidly against " +
                "the alveolar ridge.", "Relax your tongue and blow air over it so the tip flutters — " +
                "like a purring cat or an engine 'rrrrr'."),
            def("uvular", "Uvular R (ʀ)", "◠", NP, PI, "A rolled R made at the back of the throat with the uvula.", "Gargle gently without water, letting the back of your throat " +
                "vibrate — the French/German 'r'."),
            def("bilabial", "Lip Trill (ʙ)", "◌", NP, PV, "A trill made by vibrating both lips together.", "Blow air through loosely closed lips so they flap — a 'brrr' " +
                "you'd make when cold."),
        ],
    },
    {
        id: "click-consonants",
        name: "Click Consonants",
        version: 2,
        phonemes: [
            def("dental", "Dental ǀ", "❘", P, PI, "A soft click made with the tongue against the back of the " +
                "upper front teeth — the disapproving 'tsk tsk'.", "Put your tongue tip behind your top teeth and pull it away " +
                "sharply to make a light 'tut' click."),
            def("lateral", "Lateral ǁ", "❙", P, PI, "A click made at the side of the mouth, like the sound used " +
                "to urge on a horse.", "Press your tongue to the roof of your mouth and release it " +
                "from one side — the 'clip-clop' giddy-up click."),
            def("alveolar", "Alveolar ǃ", "❢", P, PI, "A sharp, hollow 'pop' click made with the tongue on the ridge " +
                "behind the upper teeth.", "Suck your tongue tip down quickly from the ridge behind your " +
                "teeth to make a loud, hollow 'clop'."),
            def("bilabial", "Bilabial ʘ", "⦿", P, PI, "A click/kiss made with both lips.", "Purse your lips and release a small kiss-like pop."),
        ],
    },
    {
        id: "ejectives",
        name: "Ejectives & Glottals",
        version: 2,
        phonemes: [
            def("glottal", "Glottal ʔ", "'", P, PI, "A catch in the throat, like the middle of 'uh-oh'.", "Briefly close your throat to stop the air, then release it — " +
                "the little catch in 'uh-oh'."),
            def("ejective-k", "Ejective kʼ", "ᵏ", P, PI, "A sharp, popping 'k' made with a burst of air from the throat.", "Say a 'k' but close your throat and squeeze the air so it pops " +
                "out crisply, like a tiny cough."),
            def("pharyngeal", "Pharyngeal ʕ", "ʕ", NP, PV, "A tight, constricted sound from deep in the throat.", "Constrict the very back of your throat and voice a low 'ah', " +
                "as if gently straining."),
            def("creak", "Vocal Fry", "﹏", NP, PI, "A low, creaky, rattling voice at the bottom of your range.", "Relax your voice and let it drop to a slow, popping creak — " +
                "like a lazy 'aaa' at the very bottom of your pitch."),
        ],
    },
    {
        id: "beatbox-core",
        name: "Beatbox Core",
        version: 2,
        phonemes: [
            def("kick", "Kick", "●", P, PI, "The deep 'boom' bass-drum sound of beatboxing.", "Say a punchy 'b' with your lips ('buh') and push a burst of " +
                "air for a deep boom."),
            def("hihat", "Hi-Hat", "×", P, PI, "A crisp 'ts' cymbal tick.", "Make a short, sharp 'ts' or 'tss' with the tip of your tongue."),
            def("snare", "Snare", "◍", P, PI, "A snappy snare-drum hit.", "Say a forceful 'pf' or 'k' burst — a sharp puff like a snare " +
                "crack."),
            def("bass", "Bass", "▁", NP, PV, "A sustained low hum providing the bassline.", "Hum a steady, low 'mmm' from deep in your chest."),
        ],
    },
    {
        id: "drumkit",
        name: "Vocal Drum Kit",
        version: 2,
        phonemes: [
            def("boom", "Boom", "◯", P, PI, "A big round low-drum boom.", "Push a deep 'boh' with rounded lips and a burst of air."),
            def("tss", "Tss", "≈", NP, PI, "A sustained hissing cymbal wash.", "Hold a long 'tsss', like escaping steam."),
            def("clap", "Clap", "◐", P, PI, "A sharp hand-clap-like crack.", "Make a quick, sharp 'p' or 'k' pop for a clap."),
            def("click", "Click", "•", P, PI, "A tiny dry tongue click.", "Make a small 'tk' click with the tip of your tongue."),
        ],
    },
    {
        id: "whistle-register",
        name: "Whistles & Registers",
        version: 1,
        phonemes: [
            def("whistle-hi", "High Whistle", "◔", NP, PV, "A clear, piercing whistle at the top of your range.", "Purse your lips into a small 'o' and blow steadily while " +
                "raising the pitch to a high, thin tone."),
            def("whistle-lo", "Low Whistle", "◕", NP, PV, "A soft, mellow whistle at the bottom of your range.", "Round your lips a little wider and blow gently for a low, " +
                "breathy whistle."),
            def("sing-oo", "Sung “oo”", "○", NP, PV, "A sustained, rounded vowel sung on 'oo'.", "Open your throat and sing a steady 'ooo' with rounded lips, " +
                "like the vowel in 'boot'."),
            def("sing-ee", "Sung “ee”", "◎", NP, PV, "A sustained, bright vowel sung on 'ee'.", "Spread your lips into a smile and sing a steady 'eee', like " +
                "the vowel in 'see'."),
        ],
    },
    {
        id: "barnyard",
        name: "Barnyard",
        version: 1,
        phonemes: [
            def("moo", "Moo", "🐄", NP, PV, "The long, low bellow of a cow.", "Sing a drawn-out, nasal 'mooo' that slides gently down in " + "pitch."),
            def("cluck", "Cluck", "🐔", P, PI, "The short, clipped cluck of a hen.", "Make a quick 'buck-buck' pop at the back of your mouth, like " +
                "a light tongue cluck."),
            def("hiss-cat", "Hiss", "🐱", NP, PI, "The drawn-out hiss of an annoyed cat.", "Bare your teeth slightly and push a steady stream of air out " +
                "for a long 'ssss' hiss."),
            def("neigh", "Neigh", "🐴", NP, PV, "The wavering whinny of a horse.", "Start high and let your voice quiver downward in a rippling " +
                "'eeeh-heh-heh' whinny."),
        ],
    },
    {
        id: "sci-fi",
        name: "Sci-Fi SFX",
        version: 1,
        phonemes: [
            def("laser", "Laser", "↘", NP, PV, "A quick downward 'pew' laser blast.", "Say 'pew' and slide the pitch sharply downward for a fast " +
                "laser zap."),
            def("zap", "Zap", "⌁", NP, PI, "A crackling electric zap.", "Make a buzzy, buzzing 'bzzt' with a tight, vibrating voice."),
            def("warp", "Warp", "↗", NP, PV, "A rising warp-drive swoosh.", "Hum a 'wooo' and sweep the pitch upward, like a spaceship " +
                "powering up."),
            def("static", "Static", "░", NP, PI, "A hissing wash of radio static.", "Push a rough, unvoiced 'shhh' with an uneven, noisy airflow."),
        ],
    },
    {
        id: "tone-contours",
        name: "Tone Contours",
        version: 1,
        experimental: true,
        phonemes: [
            def("level", "Level ˉ", "‾", NP, PV, "A flat, steady pitch held level throughout.", "Sing a single vowel and keep the pitch perfectly even, with " +
                "no rise or fall."),
            def("rising", "Rising ˊ", "╱", NP, PV, "A pitch that glides smoothly upward.", "Start low and slide your voice steadily up, like asking a " +
                "question."),
            def("dipping", "Dipping ˇ", "‿", NP, PV, "A pitch that dips down then rises back up.", "Let your voice fall to the middle then curve back up, like a " +
                "hesitant 'hmm?'."),
            def("falling", "Falling ˋ", "╲", NP, PV, "A pitch that glides smoothly downward.", "Start high and slide your voice steadily down, like a firm " +
                "statement."),
        ],
    },
];
export function buildBuiltinLibraries(now) {
    return PRESET_SPECS.map((spec) => ({
        id: spec.id,
        name: spec.name,
        version: spec.version,
        builtin: true,
        experimental: spec.experimental ?? false,
        createdAt: now,
        updatedAt: now,
        phonemes: spec.phonemes.map((p) => ({ ...p, trained: false })),
    }));
}
